import React, { useState } from 'react';
import { Output } from '../../components/index';
import SelectCcn from '../metrics/components/SelectCcn';
import CcnSettings from './components/CcnSettings';
import environment from '../../Environment';
import { isNil, propOr } from 'ramda';
import { graphql, QueryRenderer } from 'react-relay';

const CcnSettingsQuery = graphql`
  query SettingsQuery($ccnId: String!) {
    ccnSettings(ccnId: $ccnId) {
        PREVOYANCE {
            links {
                key
                value
            }
        }
        SANTE {
            links {
                key
                value
            }
        }
    }
  }
`;

const Settings = () => {
  const [selectedCcn, setSelectedCcn] = useState();

  return <Output>
    <div>
      <SelectCcn onChange={setSelectedCcn}/>

      {!isNil(selectedCcn) && <QueryRenderer
        environment={environment}
        query={CcnSettingsQuery}
        variables={{ ccnId: selectedCcn.id }}
        render={({ error, props }) => {

          if (error) {
            return <div>{error}</div>;
          }

          if (!props) {
            return null;
          }

          const ccnSettings = propOr({}, 'ccnSettings', props);

          return <CcnSettings
            ccn={selectedCcn}
            settings={ccnSettings}
          />;
        }}
      />}
    </div>
  </Output>;
};

export default Settings;
